import { WORKED } from '../data';

export function WorkedExample() {
  return (
    <div className="we-wrap">
      <div className="we-header">
        <span className="rv-eyebrow-mini">A worked example</span>
        <h3>
          Meet <em>{WORKED.name}</em>.
        </h3>
        <p>{WORKED.subtitle}</p>
      </div>
      <ol className="we-steps">
        {WORKED.steps.map((s, i) => (
          <li key={i}>
            <div className="we-step-num">{String(i + 1).padStart(2, '0')}</div>
            <div>
              <div className="we-step-label">{s.label}</div>
              <div className="we-step-text">{s.text}</div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
